import { setupAuditInterceptor } from '@britishcouncil/react-common';

import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import qs from 'query-string';
import { BaseQueryFn } from '@reduxjs/toolkit/query';

import { organisationInterceptor } from './interceptors';
import { downloadFile } from './downloadFile';

export const apiClient = axios.create({
  baseURL: `/enrolments`,
});

// Note: Auth interceptor is set up dynamically via useApiAuth hook
// 401 handling is done in the auth interceptor created by createAuthInterceptor
organisationInterceptor(apiClient);
setupAuditInterceptor(apiClient);

export const axiosBaseQuery =
  (): BaseQueryFn<
    Omit<AxiosRequestConfig, 'headers'> & {
      body?: AxiosRequestConfig['data'];
      headers?: Record<string, string | number | boolean | undefined | null>;
    },
    unknown,
    unknown,
    { downloadFile?: boolean }
  > =>
  async ({ url, body, headers, ...config }, _, extraOptions) => {
    try {
      const result = await apiClient({
        url,
        data: body,
        headers: mapToAxiosHeaders(headers),
        responseType: extraOptions?.downloadFile ? 'blob' : 'json',
        ...config,
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'none' }),
      });

      if (result.headers['content-disposition']?.includes('attachment')) {
        downloadFile(result);
      }

      return { data: result.data, meta: { headers: result.headers } };
    } catch (axiosError) {
      let err = axiosError as AxiosError;
      return {
        error: { status: err.response?.status, data: err.response?.data },
      };
    }
  };

const mapToAxiosHeaders = (originalHeaders?: Record<string, string | number | boolean | undefined | null>) => {
  const headers: AxiosRequestConfig['headers'] = {};
  if (originalHeaders) {
    Object.keys(originalHeaders).forEach((key) => {
      if (originalHeaders[key] !== undefined && originalHeaders[key] !== null) headers[key] = originalHeaders[key] as any;
    });
  }
  return headers;
};
